import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetCreditCardTypes = () =>
    request({
        url: ApiURL.Query.GetCreditCardTypes,
        method: RequestType.GET,
    });

const GetBinInstallments = (params: any) =>
    request({
        url: `${ApiURL.Query.GetBinInstallments}?typeId=${params.typeId}&page=${params.page}&pageSize=${params.pageSize}`,
        method: RequestType.GET,
    });

const GetBanks = (countryId: number = 1) =>
    request({
        url: `${ApiURL.Query.GetBanks}?countryId=${countryId}`,
        method: RequestType.GET,
    });

const GetBlackListCreditCards = (params: { binNumber?: string, page?: number, pageSize?: number }) => {
    let url = ApiURL.Query.GetBlackListCreditCards;
    const queryParams = new URLSearchParams();
    
    if (params.binNumber) queryParams.append('BinNumber', params.binNumber);
    if (params.page) queryParams.append('Page', params.page.toString());
    if (params.pageSize) queryParams.append('PageSize', params.pageSize.toString());
    
    if (queryParams.toString()) {
        url += `?${queryParams.toString()}`;
    }
    
    return request({
        url,
        method: RequestType.GET,
    });
};

const GetCreditCardTypeBinNumbers = (params: { creditCardTypeId?: string, page?: number, pageSize?: number }) => {
    let url = ApiURL.Query.GetCreditCardTypeBinNumbers;
    const queryParams = new URLSearchParams();
    
    if (params.creditCardTypeId) queryParams.append('CreditCardTypeId', params.creditCardTypeId);
    if (params.page) queryParams.append('Page', params.page.toString());
    if (params.pageSize) queryParams.append('PageSize', params.pageSize.toString());
    
    if (queryParams.toString()) {
        url += `?${queryParams.toString()}`;
    }
    
    return request({
        url,
        method: RequestType.GET,
    });
};

const BinNumberQuery = {
    GetCreditCardTypes,
    GetBinInstallments,
    GetBanks,
    GetBlackListCreditCards,
    GetCreditCardTypeBinNumbers,
};

export default BinNumberQuery;